import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/historico-plazas';

/**
 * GET Historicos Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosPlazas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Plaza
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoPlaza = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Plaza
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoPlaza = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Plaza
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoPlaza = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Plaza
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoPlaza = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
